import { render, staticRenderFns } from "./bottomMenu.vue?vue&type=template&id=364fe45c&scoped=true&"
import script from "./bottomMenu.vue?vue&type=script&lang=js&"
export * from "./bottomMenu.vue?vue&type=script&lang=js&"
import style0 from "./bottomMenu.vue?vue&type=style&index=0&id=364fe45c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364fe45c",
  null
  
)

/* custom blocks */
import block0 from "./bottomMenu.vue?vue&type=custom&index=0&blockType=comment"
if (typeof block0 === 'function') block0(component)

export default component.exports